import { Typography, Box } from "@bca/ui-library";
import { SpaceProps } from "styled-system";

interface ResultCountProps extends SpaceProps {
  resultCount: number;
  page: number;
  pageSize: number;
  isTrackedPage?: boolean;
  totalTracked?: number;
}

const formatCount = (resultCount: number): string =>
  resultCount?.toLocaleString("en-GB", {
    maximumFractionDigits: 0,
  });

const ResultCount: React.FunctionComponent<ResultCountProps> = ({
  resultCount,
  page,
  pageSize,
  isTrackedPage,
  totalTracked,
  ...props
}) => {
  if (!resultCount) return null;

  const getInterval = () => {
    const first = pageSize * (page - 1) + 1;
    const last =
      first + pageSize - 1 <= resultCount ? first + pageSize - 1 : resultCount;
    return first + " - " + last;
  };

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      {...props}
      height="auto"
    >
      <Typography variant="body" color="grey-blue" htmlTag="span">
        {getInterval()} of{" "}
        <Typography
          color="footer-blue"
          htmlTag="span"
          css={`
            font-weight: 700;
          `}
        >
          {isTrackedPage ? formatCount(totalTracked) : formatCount(resultCount)}{" "}
          {isTrackedPage ? "Tracked Vehicles" : "Vehicles"}
        </Typography>
      </Typography>
    </Box>
  );
};

export default ResultCount;
